module.exports = "<div class=gmw-verification-requirements__col> <div class=gmw-verification-requirements__icon-container> <img ng-src=\"/img/{{image}}.png\" srcset=\"/img/{{image}}.png, /img/{{image}}@2x.png 2x\"> </div> <holding-svg-icon icon=checkmark class=\"gmw-verification-requirements__checkmark mobile-only mobile-only--xxs\"> </holding-svg-icon> <span class=heading-h6 ng-transclude> </span> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/holding/modules/app/modules/holding/modules/dashboard/modules/onboarding/directives/verification-requirement/verification-requirement.html
// module id = 973
// module chunks = 0